import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { hot } from 'react-hot-loader';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { FlagsProvider } from 'flagged';
import ToastFeedback from '@/components/common/ToastFeedback/ToastFeedback';
import LayoutProvider from '@/components/layout/LayoutProvider';
import Router from '@/components/routing/Router';
import useFeatureFlags from '@/lib/hooks/swr/useFeatureFlags';
// import useHotJar from '@/lib/hooks/useHotJar';
import { Authentication } from '@/modules/Authentication';
import { DialogManagerProvider } from '@/modules/Dialogs';
import { GoogleAnalyticsProvider } from '@/modules/GoogleAnalytics';
import theme from '@/styles/theme';
import { applyPrototypes } from '@/utils/prototypes';

function App() {
  applyPrototypes();
  // useHotJar();

  const featureFlags = useFeatureFlags();

  return (
    <GoogleAnalyticsProvider>
      <HelmetProvider>
        <Helmet defaultTemplate="Instil" titleTemplate="%s | Instil" />
        <Authentication>
          <FlagsProvider features={featureFlags}>
            <StyledEngineProvider>
              <ThemeProvider theme={theme}>
                <DialogManagerProvider>
                  <LayoutProvider>
                    <CssBaseline />
                    <ToastFeedback />
                    <Router />
                  </LayoutProvider>
                </DialogManagerProvider>
                <CssBaseline />
              </ThemeProvider>
            </StyledEngineProvider>
          </FlagsProvider>
        </Authentication>
      </HelmetProvider>
    </GoogleAnalyticsProvider>
  );
}

export default hot(module)(App);
